import React from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { colors, typography } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { styledComponentWithCondition } from '@atlassian/jira-compiled-migration/src/ui/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';
import { ff } from '@atlassian/jira-feature-flagging';
import { FormattedMessage, useIntl } from '@atlassian/jira-intl';
import Image from './assets/sprint-planning.svg';
import messages from './messages.tsx';

export function FirstSprintBlankState() {
	const { formatMessage } = useIntl();

	return (
		<FirstSprintPlanning>
			<SprintPlanningImage />
			<SprintPlanningMessage>
				<SprintPlanningTitle>{formatMessage(messages.emptyFirstSprintTitle)}</SprintPlanningTitle>
				<div>
					{
						// using the FormattedMessage component as there is no support for rich text formatting in
						// format message. source - https://atlassian.slack.com/archives/CFH38E2S1/p1563173404345500
					}
					<FormattedMessage
						{...(expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)
							? messages.emptyFirstSprintDescriptionIssueTermRefresh
							: messages.emptyFirstSprintDescription)}
						values={{
							backlog: <b>{formatMessage(messages.backlog)}</b>,
							startSprint: <b>{formatMessage(messages.startSprint)}</b>,
						}}
					/>
				</div>
			</SprintPlanningMessage>
		</FirstSprintPlanning>
	);
}

export default FirstSprintBlankState;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const FirstSprintPlanning = styled2.div({
	display: 'flex',
	maxWidth: '600px',
	margin: '0 auto',
	textAlign: 'left',
	alignItems: 'center',
	justifyContent: 'center',
	minHeight: '160px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SprintPlanningImageControl = styled.div({
	height: '128px',
	width: '128px',
	backgroundPosition: 'center',
	backgroundSize: 'contain',
	backgroundRepeat: 'no-repeat',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	backgroundImage: `url(${Image})`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const SprintPlanningImageExperiment = styled2.div({
	height: '128px',
	width: '128px',
	backgroundPosition: 'center',
	backgroundSize: 'contain',
	backgroundRepeat: 'no-repeat',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	backgroundImage: `url(${Image})`,
});
//

const SprintPlanningImage = styledComponentWithCondition(
	() => ff('compiled.migration.jsw.tanuki'),
	SprintPlanningImageExperiment,
	SprintPlanningImageControl,
);

// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SprintPlanningMessageControl = styled.div`
	${typography.h500()};
	font-weight: normal;
	margin-top: 0;
	color: ${token('color.text', colors.N800)};
	padding-left: ${token('space.200', '16px')};
	line-height: 1.5;
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const SprintPlanningMessageExperiment = styled2.div({
	font: token('font.body', '14px'),
	lineSpacing: '-0.006em',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text', colors.N800),
	paddingLeft: token('space.200', '16px'),
	lineHeight: 1.5,
});

const SprintPlanningMessage = styledComponentWithCondition(
	() => ff('compiled.migration.jsw.tanuki'),
	SprintPlanningMessageExperiment,
	SprintPlanningMessageControl,
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const SprintPlanningTitle = styled2.div({
	fontWeight: 600,
	paddingBottom: token('space.050', '4px'),
});
